import React, { Component } from 'react'
import { NavLink, Switch, Route } from 'react-router-dom'

import Modal from '../Modal/Modal'

import BasicDetails from './BasicDetails'
import StructuredDetails from './StructuredDetails'

import './LBUDetails.css'

class LBUDetails extends Component {

  scrollTop = () => {
    this.modal.scrollTop()
  }

    render() {
        const lbu = this.props.lbu
        const { id, name } = lbu

        const header = (
          <nav>
            <NavLink to={`/lbus/${id}/basic`} onClick={this.scrollTop} activeClassName="active">Basic</NavLink>
            <NavLink to={`/lbus/${id}/structured`} onClick={this.scrollTop} activeClassName="active">Structured</NavLink>
          </nav>
        )

        return (
          <Modal
            extraClassName="LBUDetails"
            fullHeight={true}
            onCancel={this.props.onClose}
            mode="show"
            header={header}
            title={name}
            ref={elem => { this.modal = elem }}>

            <Switch>
              <Route path="/lbus/:id/basic" render={props => (
                <BasicDetails {...props} lbu={lbu} />
              )} />
              <Route path="/lbus/:id/structured" render={props => (
                <StructuredDetails {...props} lbu={lbu} />
              )} />
            </Switch>

          </Modal>
        )
    }
}

export default LBUDetails



// WEBPACK FOOTER //
// ./src/components/LBUs/LBUDetails.js